import {Skeleton, Stack} from "@mui/material";
import {useUser} from "../store/user-context";
import LinearProgressWIthLabel from "./_atoms/LinearProgressWIthLabel";
import Typography from "@mui/material/Typography";
import {clamp, compactHumanizedDuration} from "../utils/helpers";
import Button from "@mui/material/Button";
import { usePackageModal } from "../store/modal-context";

const UsageProgress = ({ showAddCreditsButton = true }) => {
    const userCtx = useUser();
    const packageModalCtx = usePackageModal();

    let percentageValue = 0;
    if (userCtx.totalSeconds > 0) {
        percentageValue = clamp(userCtx.usedSeconds * 100 / userCtx.totalSeconds, 0, 100);
    }

    const addCreditsBtnClickHandler = () => {
        packageModalCtx.openModal();
    }

    return <Stack
        border={1}
        borderRadius={2}
        borderColor="#ccc"
        px={2}
        py={1}
        pt={1.75}
        flexDirection='column'
        position="relative"
    >
        <Typography
            variant="body2"
            sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translate(-50%, -50%)',
                px: 1,
                bgcolor: '#fff',
                color: '#7a7a7a',
                fontSize: '0.9rem',
                fontWeight: 700,
                lineHeight: 1,
                whiteSpace: 'nowrap'
            }}
        >
            Ore Trascrizione
        </Typography>
        {(userCtx.totalSeconds > 0) && <>
            <LinearProgressWIthLabel value={percentageValue} />
            <Stack spacing={0.25}>
                <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                    <strong>Utilizzate:</strong> {compactHumanizedDuration(userCtx.usedSeconds)}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                    <strong>Totale:</strong> {compactHumanizedDuration(userCtx.totalSeconds)}
                </Typography>
            </Stack>
            {showAddCreditsButton ? (
                <Button size='small' onClick={addCreditsBtnClickHandler}>Aggiungi ore extra</Button>
            ) : null}
        </>}
        {(userCtx.totalSeconds === 0) && <>
            <LinearProgressWIthLabel value={percentageValue} />
            <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                <Skeleton />
            </Typography>
            {showAddCreditsButton ? (
                <Button>
                    <Skeleton />
                </Button>
            ) : null}
        </>}
    </Stack>
};

export default UsageProgress;
